import EDate from './utils/EDate';

import { PublicEWebinarFragment, ScheduledWebinar } from '../typesProxy';

export type EwebinarFragmentForSessions = Pick<
  PublicEWebinarFragment,
  | 'timeZone'
  | 'startDate'
  | 'endDate'
  | 'endDateEnabled'
  | 'scheduleSettings'
  | 'justInTimeModeEnabled'
  | 'viewerRoomSettings'
  | 'fullSessions'
  | 'scheduleType'
>;

export type ScheduledWebinarForSessions = Pick<
  ScheduledWebinar,
  'onWeekDays' | 'atMinutes' | 'recurringType' | 'nthDayOfMonth'
> & {
  atDate?: EDate;
};

export const RETARGETED_VISITOR_FNAME = 'Attendee';
